import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

const CheckoutPage = () => {
  const navigate = useNavigate();

  const userId = localStorage.getItem("userId") || "10";
  const deviceId = localStorage.getItem("deviceId") || "web";

  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    phone: "",
    email: "",
    pincode: "",
    address: "",
    country: "India",
    city: "",
    state: "",
    ordernote: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const validateForm = () => {
    let err = {};
    if (!formData.fname.trim()) err.fname = "First name is required";
    if (!formData.lname.trim()) err.lname = "Last name is required";
    if (!formData.phone.match(/^[0-9]{10}$/))
      err.phone = "Enter valid 10 digit mobile number";
    if (
      !formData.email.match(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/)
    )
      err.email = "Enter valid email address";
    if (!formData.pincode.match(/^[0-9]{6}$/))
      err.pincode = "Enter valid 6 digit Pin code";
    if (!formData.address.trim()) err.address = "Address is required";
    if (!formData.city.trim()) err.city = "City is required";
    if (!formData.state.trim()) err.state = "State is required";
    return err;
  };

  const fetchCart = async () => {
    try {
      const res = await axios.get(
        `https://dharajwebbackend.concentics.com/api/get_cartdata/${deviceId}/${userId}`
      );
      if (res.data.status === "success") {
        setCart(res.data.cart || []);
      }
    } catch (err) {
      console.error("Cart Fetch Error", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);

  const totalAmount = cart.reduce(
    (sum, item) => sum + item.cartprice * item.proquantity,
    0
  );

  const handleSave = async (e) => {
    e.preventDefault();

    const err = validateForm();
    if (Object.keys(err).length > 0) {
      setErrors(err);
      return;
    }

    if (cart.length === 0) {
      alert("Cart is empty!");
      return;
    }

    try {
      for (let item of cart) {
        const body = {
          ...formData,
          towncity: formData.city,
          quantity: item.proquantity,
          price: item.cartprice,
          pid: item.pid,
          status: "pending",
          totalprice: item.cartprice * item.proquantity,
          cartid: item.cart_id,
          divid: deviceId,
          cid: userId,
          procategory: item.procategory,
          promeasurement: item.promeasurement,
        };

        await axios.post(
          "https://dharajwebbackend.concentics.com/api/get_selltable",
          body
        );
      }

      alert("Order Saved Successfully!");
      navigate("/PaymentSummary");
    } catch (err) {
      console.error("Sell API Error:", err);
      alert("Error saving order!");
    }
  };

  if (loading) return <p className="text-center mt-5 fs-3">Loading…</p>;

  return (
    <>
      {/* ---------------------- GLOBAL STYLES ---------------------- */}
      <style>
        {`
          :root {
            --fs-sm: clamp(0.8rem, 1vw, 1rem);
            --fs-base: clamp(1rem, 1.4vw, 1.2rem);
            --fs-lg: clamp(1.2rem, 2vw, 1.6rem);
            --fs-xl: clamp(1.5rem, 3vw, 2.2rem);
            --fs-xxl: clamp(1.8rem, 4vw, 2.6rem);
            --radius: 14px;
          }

          .input-modern {
            font-size: var(--fs-base);
            padding: 14px 16px;
            border-radius: var(--radius);
          }

          .title-xl { font-size: var(--fs-xl); font-weight: 700; }
          .title-lg { font-size: var(--fs-lg); font-weight: 600; }

          /* ---------------------- GLASS EFFECT SUMMARY ---------------------- */
          .summary-box {
            font-size: var(--fs-base);
            border-radius: var(--radius);
            padding: 24px;
            background: rgba(255, 255, 255, 0.8);
            backdrop-filter: blur(10px);
            box-shadow: 0 8px 24px rgba(0,0,0,0.12);
          }

          .btn-modern {
            font-size: var(--fs-lg);
            padding: 14px 40px;
            border-radius: 40px;
          }

          /* ---------------------- BOTTOM BAR ---------------------- */
          .checkout-bottom {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            background: white;
            padding: 18px 0;
            z-index: 1000;
            border-top: 1px solid #eee;
            box-shadow: 0 -4px 12px rgba(0,0,0,0.05);
          }

          .checkout-bottom .container-bar {
            max-width: 1050px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            gap: 20px;
          }

          .checkout-bottom .total-price {
            font-size: var(--fs-xl);
            font-weight: 700;
          }

          .btn-modern.proceed-btn {
            background: #185E37;
            color: white;
            font-weight: 600;
          }

          /* ---------------------- MOBILE STYLES ---------------------- */
          @media (max-width: 768px) {
            .container {
              margin-top: 180px !important;
              padding: 0 16px;
            }

            .row.g-4 {
              gap: 1.5rem;
            }

            .btn-modern {
              width: 100%;
              text-align: center;
            }

            .checkout-bottom .container-bar {
              flex-direction: column;
              align-items: stretch;
              gap: 12px;
              padding: 0 16px;
            }

            .checkout-bottom .total-price {
              text-align: center;
              margin: 0;
            }
          }
        `}
      </style>

      <div className="container" style={{ marginTop: "140px", paddingBottom: "180px", maxWidth: "1050px" }}>
        <div className="row g-4">

          {/* ---------------------- LEFT FORM ---------------------- */}
          <div className="col-md-7">
            <form className="bg-white p-4 rounded shadow-sm border" onSubmit={handleSave}>
              <h2 className="title-xl mb-3">Billing Details</h2>

              {/* NAME ROW */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="fw-semibold fs-lg">First Name*</label>
                  <input name="fname" value={formData.fname} onChange={handleChange} className="form-control input-modern" />
                  {errors.fname && <p className="text-danger small">{errors.fname}</p>}
                </div>
                <div className="col-md-6 mb-3">
                  <label className="fw-semibold fs-lg">Last Name*</label>
                  <input name="lname" value={formData.lname} onChange={handleChange} className="form-control input-modern" />
                  {errors.lname && <p className="text-danger small">{errors.lname}</p>}
                </div>
              </div>

              {/* CONTACT */}
              <div className="mb-3">
                <label className="fw-semibold fs-lg">Mobile No*</label>
                <input name="phone" value={formData.phone} onChange={handleChange} className="form-control input-modern" />
                {errors.phone && <p className="text-danger small">{errors.phone}</p>}
              </div>

              <div className="mb-3">
                <label className="fw-semibold fs-lg">Email*</label>
                <input name="email" value={formData.email} onChange={handleChange} className="form-control input-modern" />
                {errors.email && <p className="text-danger small">{errors.email}</p>}
              </div>

              {/* ADDRESS */}
              <div className="mb-3">
                <label className="fw-semibold fs-lg">Pin Code*</label>
                <input name="pincode" value={formData.pincode} onChange={handleChange} className="form-control input-modern" />
                {errors.pincode && <p className="text-danger small">{errors.pincode}</p>}
              </div>

              <div className="mb-3">
                <label className="fw-semibold fs-lg">Address*</label>
                <input name="address" value={formData.address} onChange={handleChange} className="form-control input-modern" />
                {errors.address && <p className="text-danger small">{errors.address}</p>}
              </div>

              <div className="mb-3">
                <label className="fw-semibold fs-lg">Country*</label>
                <input name="country" value={formData.country} onChange={handleChange} className="form-control input-modern" />
              </div>

              {/* CITY + STATE */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="fw-semibold fs-lg">City*</label>
                  <input name="city" value={formData.city} onChange={handleChange} className="form-control input-modern" />
                  {errors.city && <p className="text-danger small">{errors.city}</p>}
                </div>

                <div className="col-md-6 mb-3">
                  <label className="fw-semibold fs-lg">State*</label>
                  <input name="state" value={formData.state} onChange={handleChange} className="form-control input-modern" />
                  {errors.state && <p className="text-danger small">{errors.state}</p>}
                </div>
              </div>

              <div className="mb-3">
                <label className="fw-semibold fs-lg">Order Note</label>
                <textarea name="ordernote" value={formData.ordernote} onChange={handleChange} rows={3} className="form-control input-modern" />
              </div>
            </form>
          </div>

          {/* ---------------------- RIGHT SUMMARY ---------------------- */}
          <div className="col-md-5">
            <div className="summary-box">
              <h3 className="mb-3 fs-xl">Order Summary ({cart.length} Items)</h3>

              {cart.map((item) => (
                <div key={item.cart_id} className="border rounded p-3 mb-3 bg-light">
                  <p className="fw-semibold m-0 fs-lg">{item.product_name}</p>
                  <p className="text-muted m-0">
                    ₹{item.cartprice} × {item.proquantity} ={" "}
                    <span className="fw-bold">₹{item.cartprice * item.proquantity}</span>
                  </p>
                </div>
              ))}

              <hr />

              <div className="d-flex justify-content-between fw-bold" style={{ fontSize: "var(--fs-lg)" }}>
                <span>Total Amount :</span>
                <span>₹{totalAmount.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>

        {/* ---------------------- BOTTOM BUTTON ---------------------- */}
        <div className="checkout-bottom shadow-lg">
          <div className="container-bar">
            <h3 className="total-price mb-0">Total: ₹{totalAmount.toFixed(2)}</h3>

            <button
              className="btn btn-modern proceed-btn"
              onClick={handleSave}
            >
              Proceed to Payment
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckoutPage;
